module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('mu-row', {
    staticClass: "reportCard top"
  }, [_c('mu-col', {
    attrs: {
      "width": "100",
      "desktop": "60",
      "tablet": "60"
    }
  }, [_c('div', {
    staticClass: "topArrow"
  }), _vm._v(" "), _c('mu-card', {
    staticClass: "bottom errorBox"
  }, [_c('mu-card-header', {
    attrs: {
      "titleClass": "upperReport",
      "title": _vm.message
    }
  }), _vm._v(" "), _c('mu-list', _vm._l((_vm.splicedReports), function(item, index) {
    return _c('mu-list-item', {
      key: 'sr-' + index,
      attrs: {
        "title": item.firstname + ' ' + item.surname,
        "describeText": item.reason
      }
    }, [_c('mu-avatar', {
      attrs: {
        "slot": "leftAvatar",
        "src": (item.profile_thumb !== null) ? item.profile_thumb : 'static/avatar.png'
      },
      slot: "leftAvatar"
    })], 1)
  }), 1), _vm._v(" "), _c('mu-card-actions', {
    attrs: {
      "align": "right"
    }
  }, [(_vm.report.reasons.length > 1 && _vm.limitSize !== Infinity) ? _c('mu-flat-button', {
    attrs: {
      "label": "View all reasons"
    },
    nativeOn: {
      "click": function($event) {
        return _vm.showAllReasons()
      }
    }
  }) : _vm._e(), _vm._v(" "), (_vm.limitSize === Infinity) ? _c('mu-flat-button', {
    attrs: {
      "label": "Hide reasons"
    },
    nativeOn: {
      "click": function($event) {
        return _vm.hideReasons()
      }
    }
  }) : _vm._e(), _vm._v(" "), (_vm.notReportingPage) ? _c('mu-flat-button', {
    attrs: {
      "label": "Handle report"
    },
    nativeOn: {
      "click": function($event) {
        return _vm.goTo(_vm.type)
      }
    }
  }) : _vm._e()], 1)], 1)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-e97b37d2","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Reporting/Report.vue
// module id = 3309
// module chunks = 1